function initialBootstrap() {}

export { initialBootstrap };
